import * as React from 'react';

import {
    Body,
    Container,
    Column,
    Head,
    Heading,
    Hr,
    Html,
    Img,
    Link,
    Preview,
    Row,
    Section,
    Text,
} from '@react-email/components';
import { InvioEmailModel } from 'Magazzino/Models/InvioEmailModel';
import dayjs from 'dayjs';

import Configurazione from '../../Configurazione';
import stringres from '../../translations/stringres';

const paddingX = {
    paddingLeft: '40px',
    paddingRight: '40px',
};

const paddingY = {
    paddingTop: '22px',
    paddingBottom: '22px',
};

const paragraph = {
    margin: '0',
    lineHeight: '2',
};

const global = {
    paddingX,
    paddingY,
    defaultPadding: {
        ...paddingX,
        ...paddingY,
    },
    paragraphWithBold: { ...paragraph, fontWeight: 'bold' },
    heading: {
        fontSize: '32px',
        lineHeight: '1.3',
        fontWeight: '700',
        textAlign: 'center',
        letterSpacing: '-1px',
    } as React.CSSProperties,
    text: {
        ...paragraph,
        color: '#747474',
        fontWeight: '500',
    },
    button: {
        border: '1px solid #929292',
        fontSize: '16px',
        textDecoration: 'none',
        padding: '10px 0px',
        width: '220px',
        display: 'block',
        textAlign: 'center',
        fontWeight: 500,
        color: '#000',
    } as React.CSSProperties,
    hr: {
        borderColor: '#E5E5E5',
        margin: '0',
    },
};

const main = {
    backgroundColor: '#ffffff',
    fontFamily:
        '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen-Sans,Ubuntu,Cantarell,"Helvetica Neue",sans-serif',
};

const container = {
    margin: '10px auto',
    width: '600px',
    maxWidth: '100%',
    border: '1px solid #E5E5E5',
};

const track = {
    container: {
        padding: '22px 40px',
        backgroundColor: '#F7F7F7',
    },
    number: {
        margin: '12px 0 0 0',
        fontWeight: 500,
        lineHeight: '1.4',
        color: '#6F6F6F',
    },
};

const message = {
    padding: '40px 74px',
    textAlign: 'center',
} as React.CSSProperties;

const adressTitle = {
    ...paragraph,
    fontSize: '15px',
    fontWeight: 'bold',
};

const recomendationsText = {
    margin: '0',
    fontSize: '15px',
    lineHeight: '1',
    paddingLeft: '10px',
    paddingRight: '10px',
};

const recomendations = {
    container: {
        padding: '20px 0',
    },
    product: {
        verticalAlign: 'top',
        textAlign: 'left' as const,
        paddingLeft: '2px',
        paddingRight: '2px',
    },
    title: { ...recomendationsText, paddingTop: '12px', fontWeight: '500' },
    text: {
        ...recomendationsText,
        paddingTop: '4px',
        color: '#747474',
    },
};

const menu = {
    container: {
        paddingLeft: '20px',
        paddingRight: '20px',
        paddingTop: '20px',
        backgroundColor: '#F7F7F7',
    },
    content: {
        ...paddingY,
        paddingLeft: '20px',
        paddingRight: '20px',
    },
    title: {
        paddingLeft: '20px',
        paddingRight: '20px',
        fontWeight: 'bold',
    },
    text: {
        fontSize: '13.5px',
        marginTop: 0,
        fontWeight: 500,
        color: '#000',
    },
    tel: {
        paddingLeft: '20px',
        paddingRight: '20px',
        paddingTop: '32px',
        paddingBottom: '22px',
    },
};

const footer = {
    policy: {
        width: '166px',
        margin: 'auto',
    },
    text: {
        margin: '0',
        color: '#AFAFAF',
        fontSize: '13px',
        textAlign: 'center',
    } as React.CSSProperties,
};

type EmailPreferitiPars = {
    parametri: InvioEmailModel;
};
export default function EmailPreferiti(p: EmailPreferitiPars) {
    return (
        <Html>
            <Head />
            <Preview>{stringres.t('riepilogoquotazione').toString()}</Preview>
            <Body style={main}>
                <Container style={container}>
                    <Section style={track.container}>
                        <Row>
                            <Column>
                                <Text style={global.paragraphWithBold}>{stringres.t('datacreazione').toString()} </Text>
                                <Text style={track.number}>{dayjs().format('YYYY-MM-DD')} </Text>
                            </Column>
                            <Column align="right">
                                <Link style={global.button}>{stringres.t('riepilogoquotazione').toString()}</Link>
                            </Column>
                        </Row>
                    </Section>
                    <Hr style={global.hr} />
                    <Section style={message}>
                        <Img
                            src={'/custom/logosocieta.png'}
                            width="66"
                            height="22"
                            alt={Configurazione().companyname}
                            style={{ margin: 'auto' }}
                        />
                        <Heading style={global.heading}>Elenco materiale selezionato</Heading>
                        <Text style={global.text}>Abbiamo preso in consegna la vostra richiesta...</Text>
                        <Text style={{ ...global.text, marginTop: 24 }}>Verrete contattati il prima possibile</Text>
                    </Section>
                    <Hr style={global.hr} />
                    <Section style={global.defaultPadding}>
                        <Text style={adressTitle}>
                            Shipping to:{' '}
                            {p.parametri.ragioneSociale + ' ' + p.parametri.nome + ' ' + p.parametri.cognome}
                        </Text>
                        <Text style={{ ...global.text, fontSize: 14 }}>{p.parametri.indirizzo}</Text>
                    </Section>
                    <Hr style={global.hr} />
                    <Hr style={global.hr} />
                    <Section style={paddingY}>
                        <Row>
                            <Text style={global.heading}>Elenco materiale selezionato:</Text>
                        </Row>

                        <div>
                            {p.parametri.preferiti.map((item, index) => (
                                <Row key={index}>
                                    <Column style={{ ...recomendations.product, paddingLeft: '4px' }} align="center">
                                        <Img
                                            src={
                                                Configurazione().apiBaseUrl +
                                                'Magazzino/GetFoto?fotoNome=' +
                                                item?.nomeFile +
                                                '&tipo=3'
                                            }
                                            alt=""
                                            width="150px"
                                        />
                                    </Column>
                                    <Column style={{ ...recomendations.product, paddingLeft: '4px' }} align="center">
                                        {/* <Text style={recomendations.title}>USWNT 2022/23 Stadium Home</Text> */}
                                        <Text style={recomendations.text}>{item.numeroBlocco}</Text>
                                    </Column>
                                    <Column style={{ ...recomendations.product, paddingLeft: '4px' }} align="center">
                                        {/* <Text style={recomendations.title}>USWNT 2022/23 Stadium Home</Text> */}
                                        <Text style={recomendations.text}>{item.qualita}</Text>
                                    </Column>
                                    <Column style={{ ...recomendations.product, paddingLeft: '4px' }} align="center">
                                        {/* <Text style={recomendations.title}>USWNT 2022/23 Stadium Home</Text> */}
                                        <Text style={recomendations.text}>{item.spessore}</Text>
                                    </Column>
                                    <Column style={{ ...recomendations.product, paddingLeft: '4px' }} align="center">
                                        {/* <Text style={recomendations.title}>USWNT 2022/23 Stadium Home</Text> */}
                                        <Text style={recomendations.text}>{item.pezzi}</Text>
                                    </Column>
                                </Row>
                            ))}
                        </div>

                        {/* <Row style={recomendations.container}>
                            <Column style={{ ...recomendations.product, paddingLeft: '4px' }} align="center">
                                <Img
                                    src={`${baseUrl}/static/nike-recomendation-1.png`}
                                    alt="Brazil 2022/23 Stadium Away Women's Nike Dri-FIT Soccer Jersey"
                                    width="100%"
                                />
                                <Text style={recomendations.title}>USWNT 2022/23 Stadium Home</Text>
                                <Text style={recomendations.text}>Women's Nike Dri-FIT Soccer Jersey</Text>
                            </Column>
                            <Column style={recomendations.product} align="center">
                                <Img
                                    src={`${baseUrl}/static/nike-recomendation-2.png`}
                                    alt="Brazil 2022/23 Stadium Away Women's Nike Dri-FIT Soccer Jersey"
                                    width="100%"
                                />
                                <Text style={recomendations.title}>Brazil 2022/23 Stadium Goalkeeper</Text>
                                <Text style={recomendations.text}>Men's Nike Dri-FIT Short-Sleeve Football Shirt</Text>
                            </Column>
                            <Column style={recomendations.product} align="center">
                                <Img
                                    src={`${baseUrl}/static/nike-recomendation-4.png`}
                                    alt="Brazil 2022/23 Stadium Away Women's Nike Dri-FIT Soccer Jersey"
                                    width="100%"
                                />
                                <Text style={recomendations.title}>FFF</Text>
                                <Text style={recomendations.text}>Women's Soccer Jacket</Text>
                            </Column>
                            <Column style={{ ...recomendations.product, paddingRight: '4px' }} align="center">
                                <Img
                                    src={`${baseUrl}/static/nike-recomendation-4.png`}
                                    alt="Brazil 2022/23 Stadium Away Women's Nike Dri-FIT Soccer Jersey"
                                    width="100%"
                                />
                                <Text style={recomendations.title}>FFF</Text>
                                <Text style={recomendations.text}>Women's Nike Pre-Match Football Top</Text>
                            </Column>
                        </Row> */}
                    </Section>
                    <Hr style={global.hr} />
                    <Section style={menu.container}>
                        <Row>
                            <Text style={menu.title}>Torna al sito principale</Text>
                        </Row>
                        <Row style={menu.content}>
                            <Column style={{ width: '33%' }} colSpan={1}>
                                <Link href="/magazzino" style={menu.text}>
                                    Home Page
                                </Link>
                            </Column>
                            <Column style={{ width: '33%' }} colSpan={1}>
                                <Link href="/preferiti" style={menu.text}>
                                    Preferiti
                                </Link>
                            </Column>
                        </Row>
                    </Section>
                    <Hr style={global.hr} />

                    <Hr style={{ ...global.hr, marginTop: '12px' }} />
                    <Section style={paddingY}>
                        <Row>
                            <Text style={{ ...footer.text, paddingTop: 30, paddingBottom: 30 }}>
                                Please contact us if you have any questions.
                            </Text>
                        </Row>
                        <Row>
                            <Text style={footer.text}>© 2024 {Configurazione().companyname}</Text>
                        </Row>
                        <Row>
                            <Text style={footer.text}>2024 - Developed by Isodata Solutions Srl -</Text>
                        </Row>
                    </Section>
                </Container>
            </Body>
        </Html>
    );
}
